import { generateFullName } from 'utils/generateFullNameUtils';

const mapCallFor = (callFor = []) =>
  callFor.map((v) => ({
    team_id: v?.contact_id,
    team_member_name: generateFullName(v),
  }));

const formatCallLogContact = (contact) => ({
  client_id: contact?.contact_id,
  client_name: generateFullName(contact),
});

const getBusinessCallLogExtras = (data) => ({
  caller_name: data?.caller_name,
  contact_extension: data?.contact_extension,
});

export const formatCreateNote = (data) => {
  const isCallLog = data?.note_type === 'call_log';
  const isIncoming = data?.call_type === 'incoming';
  const isOutgoing = data?.call_type === 'outgoing';
  let formData = {
    case_id: data.case_id,
    case_name: data.case_name,
    note_type: data.note_type,
    description: data.description,
    title: isCallLog
      ? isIncoming
        ? `${generateFullName(data?.called_by ? data?.called_by : data?.caller_name)} Called from ${data?.phone}`
        : isOutgoing
        ? `Called ${generateFullName(data?.person_called)} at ${data?.phone}`
        : ''
      : data.title,
    resolution_status: data.resolution_status,
    firm_user: data?.assign_to
      ?.filter((v) => !v?.group_id)
      .map((v) => ({
        team_id: v?.client_cognito_username,
        firm_user_id: v?.firm_user_id,
        team_member_name: generateFullName(v),
        is_confirmed: v?.is_confirmed,
      })),
    companion_link: data?.companion_link,
  };
  if (data?.note_type === 'case_note') {
    return {
      ...formData,
      groups: data.assign_to
        ?.filter((v) => v?.group_id)
        .map((v) => ({
          group_id: v?.group_id,
          group_name: v?.group_name,
          sk: v?.sk,
        })),
    };
  }

  formData = {
    ...formData,
    call_type: data?.call_type,
    call_date: data?.call_date,
    phone_number: data?.phone,
  };

  if (data?.call_type === 'incoming' && data?.called_by?.contact_id) {
    const payload = {
      ...formData,
      call_for: mapCallFor(data.call_for),
      called_by: formatCallLogContact(data.called_by),
    };

    if (data.called_by.contact_type === 'business') {
      return { ...payload, ...getBusinessCallLogExtras(data) };
    }

    return payload;
  }

  if (data?.call_type === 'outgoing' && data?.person_called?.contact_id) {
    const payload = {
      ...formData,
      person_called: formatCallLogContact(data.person_called),
    };

    if (data.person_called.contact_type === 'business') {
      return { ...payload, ...getBusinessCallLogExtras(data) };
    }

    return payload;
  }

  return formData;
};
